import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

export function exportExcelCustomHeader(excelData, fileName, customHeader) {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";

  // Get all keys from all objects in the array
  const keyHeader = customHeader.reduce((acc, obj) => {
    return acc.concat(Object.keys(obj));
  }, []);

  // Combine headers and data
  const combinedData = [
    ...customHeader,
    ...excelData.map((item) => ({
      customID: item.IDItem,
      customProduct: item.itemname,
      customUoM: item.UoMItem,
      customDesc: item.ItemDescription,
      customModel: item.model,
      customMatCost: item.MaterialLaborCost,
      customPrice: item.material_Price,
      customPriceHome: item.matPriceHome,
      customPriceThai: item.matPriceThai,
      customPriceBoon: item.matPriceBoon,
      customPriceOth: item.matPriceOth,
      customUrlHome: item.urlHome,
      customUrlThai: item.urlThai,
      customUrlBoon: item.urlBoon,
      customUrlOth: item.urlOth,
      customSearchOn: item.last_updated,
    })),
  ];

  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(combinedData, {
    header: keyHeader,
    skipHeader: true,
  });

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}
